<template>
  <div>
    <v-main>
      <v-sheet class="ml-6 py-4 py-md-8 py-lg-12 px-2 px-md-6 px-lg-12">
        <template v-if="loading">
          <opq-loading />
        </template>
        <template v-else>
          <slot name="default"></slot>
        </template>
      </v-sheet>
    </v-main>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
export default {
  computed: {
    ...mapGetters(["sas", "ressources"])
  },

  props: {
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

